import _styled from "styled-components";
import React from 'react';
import { highlightsStyle } from './Highlights.style';
export const Highlights = _ref => {
  let {
    items,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, rest, items.map(item => /*#__PURE__*/React.createElement("span", {
    key: item,
    dangerouslySetInnerHTML: {
      __html: item
    },
    "data-ref": "highlight"
  })));
};
export default Highlights;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Highlights___StyledDiv",
  componentId: "sc-1sav9gx-0"
})(["", ""], highlightsStyle);
//# sourceMappingURL=Highlights.js.map